import { useState, useEffect } from "react";
import { getFeaturedCompanies } from "../../../service/api";
import { useNavigate, Link } from "react-router-dom";

// Swiper imports
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";

function FeaturedCompany() {
  const [companies, setCompanies] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchCompanies = async () => {
      try {
        const res = await getFeaturedCompanies();
        if (res?.data?.data) {
          setCompanies(res.data.data);
        }
      } catch (error) {
        console.error("Error fetching featured companies:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchCompanies();
  }, []);

  const truncateText = (text, limit = 50) => {
    if (!text) return "";
    return text.length > limit ? text.substring(0, limit) + "..." : text;
  };

  if (loading) {
    return <div className="text-center py-5">Loading...</div>;
  }

  return (
    <section className="topEmployers pt-50 pb-50">
      <div className="site-width">
        <div className="titleSection text-center">
          <h2>Featured companies actively hiring</h2>
          {/* <p>Find the right career opportunity for you</p> */}
        </div>

        <div className="featuredcompWrap">
          <Swiper
            modules={[Navigation]}
            navigation
            spaceBetween={20}
            slidesPerView={3}
            breakpoints={{
              320: { slidesPerView: 1 },
              768: { slidesPerView: 2 },
              1024: { slidesPerView: 3 },
            }}
          >
            {companies.map((company, index) => (
              <SwiperSlide key={index}>
                <div className="featureComCard border rounded-lg p-4 shadow-md">
                  <div className="fcomLogo flex justify-center mb-3">
                    <img
                      src={
                        company.image
                          ? company.image
                          : "/assets/img/company-profiles/image-1.png"
                      }
                      alt={company.companyName}
                      className="h-16 object-contain"
                    />
                  </div>

                  <div className="featurecompTitle text-center">
                    <h4 className="font-semibold">{company.companyName}</h4>
                  </div>

                  <div className="featurecompara text-gray-600 text-sm mt-2">
                    <p>{truncateText(company.aboutCompany, 50)}</p>
                  </div>

                  <div className="flistbtns text-center mt-4">
                    <Link
                      to={`/company-job-posts/${company.companyId}`}
                      className="text-blue-600 font-medium"
                    >
                      View Jobs <i className="fa-solid fa-arrow-right"></i>
                    </Link>
                  </div>
                </div>
              </SwiperSlide>
            ))}
          </Swiper>
        </div>
      </div>
    </section>
  );
}

export default FeaturedCompany;
